/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Pre_Roll_LabelInputs */

const en_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-roll`)
};

const fr_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-roll`)
};

const de_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Roll`)
};

const it_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-roll`)
};

const ru_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно скрученный джойнт`)
};

const es_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-roll`)
};

const zh_cn2_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预卷`)
};

const ja_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレロール`)
};

const hi_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्री-रोल`)
};

const pt_pt2_audio_recorder_pre_roll_label = /** @type {(inputs: Audio_Recorder_Pre_Roll_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-enrolado`)
};

/**
* | output |
* | --- |
* | "Pre-roll" |
*
* @param {Audio_Recorder_Pre_Roll_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_pre_roll_label = /** @type {((inputs?: Audio_Recorder_Pre_Roll_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Pre_Roll_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_pre_roll_label(inputs)
	if (locale === "de") return de_audio_recorder_pre_roll_label(inputs)
	if (locale === "it") return it_audio_recorder_pre_roll_label(inputs)
	if (locale === "ru") return ru_audio_recorder_pre_roll_label(inputs)
	if (locale === "es") return es_audio_recorder_pre_roll_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_pre_roll_label(inputs)
	if (locale === "ja") return ja_audio_recorder_pre_roll_label(inputs)
	if (locale === "hi") return hi_audio_recorder_pre_roll_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_pre_roll_label(inputs)
	return en_audio_recorder_pre_roll_label(inputs)
});